/**
 * MIRRORED FILE: keep byte-identical in Prologue and Tributary.
 *   prologue:  src/components/ProgressBars/contributionDisplay.ts
 *   tributary: src/app/(pages)/contribute/[school]/components/contribution-display.ts
 * Rule: .ai/constitution (contribution progress parity). Change both copies in twin PRs.
 */

/** Which presentation the contribution progress bar renders. */
export type ContributionDisplay = 'ladder' | 'levels'

/** The part of a normalized contribution goal the resolver reads. */
export interface ContributionDisplayGoal {
  strategy?: string | null
}

/** The feature flags the resolver reads. */
export interface ContributionDisplayFlags {
  levelTracker: boolean
}

/**
 * Decides which contribution progress bar renders. This is the only place the
 * choice is made (zoomed-in-milestones ARD decision #6).
 *
 * Returns `levels` only when the level-tracker kill switch is on, the goal uses
 * the milestone strategy, and at least one level can be derived (`levelCount`
 * is min(rungs, level definitions), from the level helpers). Everything else,
 * including a missing goal, renders the `ladder`.
 */
export function resolveContributionDisplay(
  goal: ContributionDisplayGoal | null | undefined,
  flags: ContributionDisplayFlags,
  levelCount: number,
): ContributionDisplay {
  if (!flags.levelTracker) return 'ladder'
  if (goal?.strategy !== 'milestone') return 'ladder'
  if (!(levelCount >= 1)) return 'ladder'
  return 'levels'
}
